// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as api from "./config/api.js"
import ElementUI from 'element-ui';
//import 'lib-flexible/flexible'
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/style/style.css"
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

//  自定义参数选项配置
Vue.use(VueLazyload, {
  preLoad: 1.3, // 提前加载高度（数字 1 表示 1 屏的高度） 默认值:1.3
  error: 'dist/error.png', // 当加载图片失败的时候
  loading: 'dist/loading.gif', // 图片加载状态下显示的图片
  attempt: 1 //  加载错误后最大尝试次数 默认值:1
})


import global_ from './components/global' //全局变量
Vue.prototype.GLOBAL = global_

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap,{ak:'Ln1vwbwstY2n8dSWIC4kVdBkOMYOQon2'})

import $ from 'jquery'

Vue.prototype.api = api;
Vue.use(ElementUI);
Vue.config.productionTip = false

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js